import FilterMenu from "./filtermenu.js";
import SelectedFilters from "./selectedfilters.js";
import FilterValues from "./filtervalues.js";
import PriceRangeFilter from "./pricerangefilter.js";
import UpdateFilterUrl from "./updatefilterurl.js";
import SubSearchFilter from "./subsearchfilter.js";
import ProductQuantityFilter from "./productquantityfilter.js";
import { prodListValues } from './shared.js';

var currentUrl;

// set values from RouteData and QueryString
class UpdatePageFromUrl {
    update() {
        FilterMenu.unSelectAllFilters(false);

        currentUrl = window.location.href;

        var filterCount = this.setColorFilter() +
            this.setRatingFilter() +
            this.setProductionTimeFilter() +
            this.setImprintLocationCountFilter() +
            this.setImprintColorCountFilter() +
            this.setTagFilter() +
            this.setpriceRangeFilter() +
            this.setSubSearch() +
            this.setProductQuantity();

        this.setPageNumber();
        this.setSortOrder();
        this.setPageSize();

        // If there are no filters applied make sure that the clear all filters option is not visible.
        if (filterCount === 0) {
            SelectedFilters.removeAllFromSelectedFilter();
        }
    };

    setpriceRangeFilter() {
        var matches = prodListValues.pricePattern.exec(currentUrl);
        var amounts = [];

        if (matches) {
            var vals = matches[0].split('/');
            if (vals.length >= 3) {
                amounts = amounts.concat(vals[2].split('-'));

                if (isNaN(parseFloat(amounts[0])) || isNaN(parseFloat(amounts[1]))) {
                    return 0;
                }

                var priceMin = (amounts[0] / 100);
                var priceMax = (amounts[1] / 100);

                PriceRangeFilter.update(priceMin, priceMax);
            }
        }

        return FilterValues.getPriceFilter().length;
    };

    setColorFilter() {
        /* set color filters from url */
        var matches = prodListValues.colorPattern.exec(currentUrl);
        var ids = [];
        var startLen = FilterValues.getColorFilter().length;

        if (matches) {
            var vals = matches[0].split('/');

            if (vals.length >= 3) {
                ids = ids.concat(vals[2].split('-'));

                FilterMenu.markSelectedReload(FilterValues.getColorFilter(), ids, FilterValues.getColorElementId);
            }
        }

        FilterMenu.markUnSelectedReload(FilterValues.getColorFilter(), ids, FilterValues.getColorElementId, startLen);

        return FilterValues.getColorFilter().length;
    };

    setRatingFilter() {
        /* set rating filter from url */
        var matches = prodListValues.ratingPattern.exec(currentUrl);
        var ids = [];
        var startLen = FilterValues.getRatingFilter().length;

        if (matches !== null) {
            var vals = matches[0].split('/');

            if (vals.length >= 3) {
                ids = ids.concat(vals[2].split('-'));

                FilterMenu.markSelectedReload(FilterValues.getRatingFilter(), ids, FilterValues.getRatingElementId);
            }
        }
        FilterMenu.markUnSelectedReload(FilterValues.getRatingFilter(), ids, FilterValues.getRatingElementId, startLen);

        return FilterValues.getRatingFilter().length;
    };

    setProductionTimeFilter() {
        /* set production time filter from url */
        var matches = prodListValues.prodTimePattern.exec(currentUrl);
        var ids = [];
        var startLen = FilterValues.getProdTimeFilter().length;

        if (matches !== null) {
            var vals = matches[0].split('/');

            if (vals.length >= 3) {
                ids = ids.concat(vals[2].split('-'));

                FilterMenu.markSelectedReload(FilterValues.getProdTimeFilter(), ids, FilterValues.getProductionTimeElementId);
            }
        }
        FilterMenu.markUnSelectedReload(FilterValues.getProdTimeFilter(), ids, FilterValues.getProductionTimeElementId, startLen);

        return FilterValues.getProdTimeFilter().length;
    };

    setImprintLocationCountFilter() {
        /* set imprint location filter from url */
        var matches = prodListValues.imprintLocationCountPattern.exec(currentUrl);
        var ids = [];
        var startLen = FilterValues.getImprintLocationCountFilter().length;

        if (matches !== null) {
            var vals = matches[0].split('/');

            if (vals.length >= 3) {
                ids = ids.concat(vals[2].split('-'));

                FilterMenu.markSelectedReload(FilterValues.getImprintLocationCountFilter(), ids, FilterValues.getImprintLocationCountElementId);
            }
        }
        FilterMenu.markUnSelectedReload(FilterValues.getImprintLocationCountFilter(), ids, FilterValues.getImprintLocationCountElementId, startLen);

        return FilterValues.getImprintLocationCountFilter().length;
    };

    setImprintColorCountFilter() {
        /* set imprint color filter from url */
        var matches = prodListValues.imprintColorCountPattern.exec(currentUrl);
        var ids = [];
        var startLen = FilterValues.getImprintColorCountFilter().length;

        if (matches !== null) {
            var vals = matches[0].split('/');

            if (vals.length >= 3) {
                ids = ids.concat(vals[2].split('-'));

                FilterMenu.markSelectedReload(FilterValues.getImprintColorCountFilter(), ids, FilterValues.getImprintColorCountElementId);
            }
        }
        FilterMenu.markUnSelectedReload(FilterValues.getImprintColorCountFilter(), ids, FilterValues.getImprintColorCountElementId, startLen);

        return FilterValues.getImprintColorCountFilter().length;
    };

    setPageNumber() {
        /* set page number from url */
        var matches = prodListValues.pagePattern.exec(currentUrl);
        if (matches !== null) {
            var vals = matches[0].split('=');

            if (vals.length >= 2) {
                FilterValues.addPageNumber(vals[1]);
            }
        }
    };

    setPageSize() {
        /* set page number from url */
        const matches = prodListValues.itemsPerPagePattern.exec(currentUrl);
        var page = FilterValues.getDefaultPageSize();

        if (matches !== null) {
            var vals = matches[0].split('=');

            if (vals.length >= 2) {
                page = vals[1];
            }
        } else {
            const element = document.getElementById('itemsPerPageDropDown');

            if (element && parseInt(element.value) !== page) {
                page = parseInt(element.value);
                UpdateFilterUrl.updatePageSize(page);
            }
        }

        FilterMenu.setPageSize(page);
    };

    setSubSearch() {
        var matches = prodListValues.subSearchPattern.exec(currentUrl);
        SubSearchFilter.clear();
        if (matches !== null) {
            var vals = matches[0].split('=');

            if (vals.length >= 2) {
                var term = unescape(vals[1]);
                SubSearchFilter.update(term);
                return 1;
            }
        }

        return 0;
    };

    setProductQuantity() {
        var matches = prodListValues.productQuantityPattern.exec(currentUrl);
        ProductQuantityFilter.clear();
        if (matches !== null) {
            var vals = matches[0].split('/');

            if (vals.length >= 2) {
                var term = unescape(vals[2]);
                ProductQuantityFilter.update(term);
                return 1;
            }
        }

        return 0;
    };

    setSortOrder() {
        /* set filter order from url*/
        const matches = prodListValues.sortByPattern.exec(currentUrl);
        var sort = FilterValues.getDefaultSort();

        if (matches) {
            for (var i = 0; i < prodListValues.sortMap.length; i++) {
                if (prodListValues.sortMap[i].q.toLowerCase() === matches[0].toLowerCase()) {
                    sort = prodListValues.sortMap[i].v.replace('string:', '');
                    break;
                }
            }
        }

        FilterMenu.setFilterOrder(FilterValues.getSortElementId(sort), false);
    };

    setTagFilter() {
        /* set tag filters from url */
        var matches = prodListValues.tagPattern.exec(currentUrl);
        var ids = [];
        var startLength = FilterValues.getTagFilter().length;
        var defaultTag = this.checkCustomUrl();

        if (matches) {
            var vals = matches[0].split('/');

            if (vals.length >= 3) {
                ids = ids.concat(vals[2].split('-'));
            }
        }

        if (defaultTag.length) {
            ids = ids.concat(defaultTag.split('-'));
        }

        if (ids.length) {
            FilterMenu.addTagFilters();
        }

        FilterMenu.markSelectedReload(FilterValues.getTagFilter(), ids, FilterValues.getTagElementId);
        FilterMenu.markUnSelectedReload(FilterValues.getTagFilter(), ids, FilterValues.getTagElementId, startLength);

        return FilterValues.getTagFilter().length;
    };

    checkCustomUrl() {
        /* set values for rewriten urls (i.e. 'athletic-tshirts' is 'tag/97/t/4531' */
        var defaultTag = document.getElementById('rewriteDefaultTag').value;
        var urlVals = currentUrl.split('/');
        var urlVals2 = urlVals[3].split('?');
        if (document.getElementById('filterRewrite').value === '') {
            if (defaultTag !== '' && currentUrl.indexOf(document.getElementById('FilterFriendlyUrl').value) === -1) {
                document.getElementById('filterRewrite').value = urlVals2[0];
            } else {
                defaultTag = '';
                document.getElementById('rewriteDefaultTag').value = '';
            }
        } else if (urlVals2[0] !== document.getElementById('filterRewrite').value) {
            defaultTag = '';
        }

        return defaultTag;
    };
}

export default new UpdatePageFromUrl();
